import { Box, BoxProps } from '@air/zephyr';

export interface AgencyContainerProps extends BoxProps {}

export const AgencyContainer = ({ tx, ...restOfProps }: AgencyContainerProps) => (
  <Box
    tx={{
      width: '100%',
      maxWidth: 1224,
      px: 32,
      mx: 'auto',
      ...tx,
    }}
    {...restOfProps}
  />
);
